var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "code-wrapper" }, [
    _c(
      "div",
      { staticClass: "code-logo" },
      [
        _c("icon-font", {
          staticStyle: { "font-size": "170px" },
          attrs: { type: "gb-icon-yicangxinlogo" },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "code-main" },
      [
        _c(
          "div",
          { staticClass: "code-main-switch" },
          [
            _c("icon-font", {
              attrs: { type: "gb-icon-dingding1" },
              on: { click: _vm.toDing },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "code-main-title" }, [_vm._v("扫描登录")]),
        _c("div", { staticClass: "code-main-title__sub" }, [
          _vm._v("请使用微信扫描二维码登录"),
        ]),
        _c("div", { staticClass: "code-main-pic" }, [
          _vm.url
            ? _c("img", { attrs: { width: "270", src: _vm.url, alt: "" } })
            : _vm._e(),
          _c("img", {
            staticClass: "avatar_icon",
            attrs: {
              width: "32",
              height: "32",
              src: require("@/assets/wx.png"),
              alt: "",
            },
          }),
        ]),
        _c(
          "div",
          { staticClass: "code-main-btn" },
          [
            _c(
              "a-button",
              { attrs: { type: "link" }, on: { click: _vm._WxGetQRCode } },
              [
                _vm.loading
                  ? _c("a-icon", { attrs: { type: "loading" } })
                  : _c("a-icon", { attrs: { type: "sync" } }),
                _vm._v(" 刷新 "),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "a-button",
          {
            staticClass: "code-main-back",
            attrs: { type: "link" },
            on: { click: _vm.back },
          },
          [_vm._v("返回登录")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }